import { PromotionRewardTarget } from '../components/RegistrationOfferImage/RegistrationOfferImage.constants';

export const formatRewardDescription = (reward: {
  rewardTarget?: (typeof PromotionRewardTarget)[keyof typeof PromotionRewardTarget];
}) => {
  const { rewardTarget } = reward;
  switch (rewardTarget) {
    case PromotionRewardTarget.FreeSpins:
      return 'Free Spins';
    case PromotionRewardTarget.Coins:
      return 'Bonanza Coins';
    case PromotionRewardTarget.InstantWheel:
      return 'Wheel Spins';
    case PromotionRewardTarget.Bonus:
      return 'Bonus';
    case PromotionRewardTarget.Cash:
      return 'Cash';
    default:
      return `${reward.rewardTarget}`;
  }
};
